import React, { Component } from 'react';

import Axios from 'axios';
import { getUser } from '../actions/session';
import { Notifications } from '../components/common/notification';
import { USER_DELETE_SERVER_URL } from '../config/rest_endpoints';

/**
 * DeleteServerConfig - Premium Delete Confirmation
 *
 * Confirmation dialog for deleting server configurations
 * with warning styling and smooth animations.
 */
class DeleteServerConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      User: getUser(),
      serverName: '',
      serverId: '',
      ip: '',
      port: '',
      mask: '',
      status: '',
      msg: '',
      isLoad: false
    };
    this.deleteServer = this.deleteServer.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      serverName: newProps.deleteDetails.serverTitle,
      serverId: newProps.deleteDetails.id,
      ip: newProps.deleteDetails.ip,
      port: newProps.deleteDetails.port,
      mask: newProps.deleteDetails.mask,
      status: newProps.deleteDetails.active
    });
  }

  deleteServer() {
    const { serverId, User } = this.state;
    let userId = User.id;
    var headers = { Authorization: 'Bearer ' + User.token };
    this.setState({ isLoad: true });
    Axios.delete(`${USER_DELETE_SERVER_URL}/${userId}/server/${serverId}/delete`, { headers })
      .then((res) => {
        if (res) {
          this.setState({
            msg: res.data.message,
            isLoad: false
          });
          Notifications.notify(this.state.msg, 'Updated', 'success');
          this.props.close();
          this.props.serverListing();
        }
      })
      .catch((err) => {
        const errRes = err.response.data;
        this.setState({ isLoad: false });
        Notifications.notify(errRes.message, 'Failed', 'error');
      });
  }

  render() {
    const { serverName, ip, port, isLoad } = this.state;

    return (
      <div style={{ padding: '1rem', animation: 'fadeIn 0.3s ease' }}>

        {/* Warning Icon */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '1.5rem'
          }}
        >
          <div
            style={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              background: 'rgba(239, 68, 68, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <i
              className="icon-warning"
              style={{
                fontSize: '2rem',
                color: '#EF4444'
              }}
            ></i>
          </div>
        </div>

        {/* Confirmation Text */}
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <h4
            style={{
              fontWeight: 700,
              color: 'var(--color-text)',
              marginBottom: '0.5rem',
              fontSize: '1.125rem'
            }}
          >
            Delete Server?
          </h4>
          <p
            style={{
              color: 'var(--color-text-secondary)',
              fontSize: '0.875rem',
              margin: 0
            }}
          >
            Are you sure you want to delete this server configuration?
          </p>
        </div>

        {/* Server Details Card */}
        <div
          style={{
            background: 'var(--color-bg-subtle)',
            borderRadius: '12px',
            padding: '1rem',
            marginBottom: '1.5rem',
            border: '1px solid var(--color-border)'
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem'
            }}
          >
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: '10px',
                background: 'rgba(239, 68, 68, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <i className="icon-server" style={{ color: '#EF4444' }}></i>
            </div>
            <div>
              <div style={{ fontWeight: 600, color: 'var(--color-text)' }}>
                {ip || serverName || 'Server'}
              </div>
              <div style={{ fontSize: '0.8125rem', color: 'var(--color-text-tertiary)' }}>
                Port: {port || 'N/A'}
              </div>
            </div>
          </div>
        </div>

        {/* Warning Notice */}
        <div
          style={{
            background: 'rgba(239, 68, 68, 0.05)',
            borderRadius: '10px',
            padding: '0.75rem 1rem',
            marginBottom: '1.5rem',
            border: '1px solid rgba(239, 68, 68, 0.15)'
          }}
        >
          <p
            style={{
              margin: 0,
              fontSize: '0.8125rem',
              color: '#DC2626',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            <i className="icon-notification2"></i>
            This action cannot be undone.
          </p>
        </div>

        {/* Action Buttons */}
        <div
          style={{
            display: 'flex',
            gap: '0.75rem',
            justifyContent: 'flex-end'
          }}
        >
          <button
            type="button"
            onClick={this.props.close}
            style={{
              background: 'var(--color-surface)',
              border: '1px solid var(--color-border)',
              borderRadius: '10px',
              padding: '0.625rem 1.25rem',
              color: 'var(--color-text)',
              fontWeight: 600,
              fontSize: '0.875rem',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={this.deleteServer}
            disabled={isLoad}
            style={{
              background: isLoad ? 'var(--color-bg-subtle)' : 'linear-gradient(135deg, #EF4444 0%, #DC2626 100%)',
              border: 'none',
              borderRadius: '10px',
              padding: '0.625rem 1.25rem',
              color: isLoad ? 'var(--color-text-tertiary)' : 'white',
              fontWeight: 600,
              fontSize: '0.875rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              cursor: isLoad ? 'not-allowed' : 'pointer',
              boxShadow: isLoad ? 'none' : '0 4px 14px rgba(239, 68, 68, 0.3)'
            }}
          >
            {isLoad ? (
              <>
                <i className="icon-spinner2 spinner"></i>
                Deleting...
              </>
            ) : (
              <>
                <i className="icon-trash"></i>
                Delete Server
              </>
            )}
          </button>
        </div>
      </div>
    );
  }
}

export default DeleteServerConfig;
